import { renderPrimitivesMethods } from "components/Topology/staticLayer/vectorElements/renderPrimitivesMethods";
import { nodes, nodesPrint } from "../../configs/nodesConfig";
import { topologyColors } from "../../configs/topologyColors";
import { topologyConfig } from "../../configs/topologyConfig";

const { blue500 } = topologyColors;
const { nodeHeight, nodePadding } = topologyConfig;
const { drawRect, drawText, drawIcon } = renderPrimitivesMethods;

export const renderNodesMethods = {
  drawNode(
    ref,
    startX,
    startY,
    {
      kind = "component",
      title,
      subTitle,
      iconName,
      parentConnectionType,
      selectedAccessories,
      isPrint,
      ...nodeData
    },
  ) {
    const isNodeWithInfo =
      !!nodeData?.info &&
      kind !== "fam" &&
      kind !== "fame" &&
      kind !== "squareNode";

    const accessory = selectedAccessories?.[0]?.currentPresentation;

    let titleY;
    if (subTitle && accessory) {
      titleY = startY + 12;
    } else if (subTitle) {
      titleY = startY + 20;
    } else {
      titleY = startY + nodeHeight / 2 - 2;
    }
    const subTitleY = accessory ? startY + nodeHeight / 2 + 2 : startY + 36;
    const accessoryY = startY + nodeHeight - 8;

    const paramsByKind = isPrint
      ? nodesPrint[kind] || nodesPrint.component
      : nodes[isNodeWithInfo ? "fam" : kind] || nodes.component; // Nodes with info mark have the same styles with FAM nodes
    if (kind === "squareNode") {
      drawRect(ref, startX, startY + 52, paramsByKind.title);
      drawRect(ref, startX, startY, paramsByKind.icon);
      drawIcon(ref, startX + 10, startY + 10, {
        size: 32,
        color: paramsByKind.icon.iconColor,
        name: iconName,
      });
      drawText(
        ref,
        startX + paramsByKind.title.width / 2,
        startY + nodeHeight + paramsByKind.title.height / 2 + 2,
        title,
        {
          fs: 14,
          fw: "600",
          color: paramsByKind.title.textColor,
          dominantBaseline: "middle",
          textAnchor: "middle",
        },
      );
    } else {
      drawRect(ref, startX, startY, {
        ...paramsByKind?.title,
        stroke: paramsByKind?.title.stroke,
        fill: paramsByKind?.title.fill,
      });

      drawRect(ref, startX, startY, paramsByKind?.icon);

      drawIcon(ref, startX + 10, startY + 10, {
        size: 32,
        color: paramsByKind.icon.iconColor,
        name: iconName,
      });

      isPrint &&
        drawText(ref, startX + nodeHeight + nodePadding, titleY, title, {
          fs: 16,
          fw: "600",
          color: paramsByKind.title.textColor,
          dominantBaseline: "middle",
        });

      parentConnectionType === "WIRELESS" &&
        drawRect(ref, startX, startY, {
          width: 2,
          height: nodeHeight,
          fill: blue500,
        });

      isPrint &&
        subTitle &&
        drawText(ref, startX + nodeHeight + nodePadding, subTitleY, subTitle, {
          ff: "ModeratW01-45Rg, Moderat, Arial, Lucida Grande",
          fs: 14,
          fw: "400",
          color: paramsByKind.title.textColor,
          dominantBaseline: "middle",
        });

      isPrint &&
        accessory &&
        drawText(
          ref,
          startX + nodeHeight + nodePadding,
          accessoryY,
          selectedAccessories[0].currentPresentation,
          {
            ff: "ModeratW01-45Rg, Moderat, Arial, Lucida Grande",
            fs: 14,
            fw: "400",
            color: paramsByKind.title.textColor,
            dominantBaseline: "middle",
          },
        );
    }
  },
};
